import * as React from 'react';
import { FC } from 'react';

import { useRouter } from 'expo-router';

import { ModalItemUnavailableView } from 'components/modal-item-unavailable/modal-item-unavailable.view';
import { ServiceMode } from 'generated/graphql-gateway';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { IUseDialogComponentProps } from 'hooks/use-dialog-modal';
import { useFeatureStaticMenu } from 'hooks/use-feature-static-menu';
import { t } from 'state/intl/translations';
import { useServiceModeContext } from 'state/service-mode';
import { routes } from 'utils/routing';

/**
 *
 * This Modal appears if a the reward benefit item is not available in
 * the users selected store or the nearest store that can deliver.
 *
 */
export const ModalRewardItemUnavailable: FC<React.PropsWithChildren<
  IUseDialogComponentProps & { rewardName: string }
>> = ({ onDismiss, rewardName }) => {
  const { itemUnavailableModal } = useFeatureStaticMenu();

  const { serviceMode } = useServiceModeContext();
  const router = useRouter();

  const imageAlt = `${t('itemsUnavailable')} ${t('image')}`;

  const isDelivery = serviceMode === ServiceMode.DELIVERY;

  const {
    header,
    image,
    body: defaultBodyText,
    selectNew: selectNewBtnText,
    itemNotAvailableForDelivery,
  } = itemUnavailableModal || {};

  const body = isDelivery ? itemNotAvailableForDelivery : defaultBodyText;

  useLogUserErrorMessage({ message: body, severity: LogUserErrorSeverity.Informational });

  if (!itemUnavailableModal) {
    return null;
  }

  const continueBtnText = t('continue');

  const handleChangeStore = () => {
    onDismiss();
    router.navigate(isDelivery ? routes.deliveryAddress : routes.storeLocator);
  };

  return (
    <ModalItemUnavailableView
      header={header}
      image={image}
      body={body}
      continueBtnText={continueBtnText}
      selectNewBtnText={selectNewBtnText}
      handleContinue={onDismiss}
      handleChangeStore={handleChangeStore}
      unavailableItemName={rewardName}
      imageAlt={imageAlt}
      hideSelectNewBtn={isDelivery}
    />
  );
};
